import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTpSessionErrorReason implements BaseEnumType {
  private static allValues: EnumTpSessionErrorReason[] = []; // make sure this is top-most
  
  public static none = new EnumTpSessionErrorReason(0, "None", "enum_tp_session_error_reason_none");
  public static notFound = new EnumTpSessionErrorReason(1, "NotFound", "enum_tp_session_error_reason_not_found");
  public static onHold = new EnumTpSessionErrorReason(2, "OnHold", "enum_tp_session_error_reason_on_hold");
  public static invalidCredentials = new EnumTpSessionErrorReason(3, "InvalidCredentials", "enum_tp_session_error_reason_invalid_credentials");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTpSessionErrorReason.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumTpSessionErrorReason.none; }
  public isNotFound() { return this === EnumTpSessionErrorReason.notFound; }
  public isOnHold() { return this === EnumTpSessionErrorReason.onHold; }
  public isInvalidCredentials() { return this === EnumTpSessionErrorReason.invalidCredentials; }

  public static getValues(): readonly EnumTpSessionErrorReason[] {
    return EnumTpSessionErrorReason.allValues;
  }

  public static getValuesExcept0(): readonly EnumTpSessionErrorReason[] {
    return EnumTpSessionErrorReason.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTpSessionErrorReason {
    const found = EnumTpSessionErrorReason.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTpSessionErrorReason - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTpSessionErrorReason): EnumTpSessionErrorReason {
    const found = name ? EnumTpSessionErrorReason.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTpSessionErrorReason - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTpSessionErrorReason>): boolean {
    return this.key === other?.key;
  }
}